import axios from "axios";

export default class SecurityService {
    public static get CSRFToken(): string {
        try {
            const elem = document && document.getElementsByClassName("security-container")[0];
            if (elem) {
                return elem.getElementsByTagName("input")[0].value;
            } else {
                return null;
            }
        } catch (e) {
            throw e;
        }
    }

    public static createAxiosInstance(baseURL: string) {
        return axios.create({
            baseURL,
            headers: {
                Pragma: "no-cache",
                __RequestVerificationToken: SecurityService.CSRFToken,
            },
        });
    }

    public static createAxiosInstanceWithToken(baseURL: string, securityToken: string) {
        return axios.create({
            baseURL,
            headers: {
                Pragma: "no-cache",
                __RequestVerificationToken: securityToken,
            },
        });
    }
}
